import React from "react";
import {OverlayTrigger, Popover, Tooltip as Label} from "react-bootstrap";

export const Tooltip = ({children, label}) => {
    return (
        <OverlayTrigger overlay={<Label id="tooltip-disabled">{label}</Label>}>
            {children}
        </OverlayTrigger>
    )
}



export const PopoverMessage = ({children, label, header}) => {

    const popover = (
        <Popover id="popover-basic">
            { header && <Popover.Header as="h3">{ header }</Popover.Header> }
            <Popover.Body>
                { label }
            </Popover.Body>
        </Popover>
    );

    return (
        <OverlayTrigger overlay={popover}>
            {children}
        </OverlayTrigger>
    )
}
